export interface SplitPane {
  left: string;
  right: string;
}
